import React, { useState } from 'react';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
import PlayButton from 'assets/images/Play-Button-S.png';
import { HTMLView } from 'components/atoms/htmlView';
//eslint-disable-next-line
import styles from "./styles.scss";

const PastEventsMobileCard = props => {
  const {
    heading,
    description,
    image,
    videoUrl,
    videoThumbNail,
    date,
    venue,
    location,
  } = props.data;
  const [videoOverlay, showVideOverlay] = useState(false);

  const showOverlay = videoOverlay ? (
    <OverlayPortal>
      <OverlayModal
        data={videoUrl}
        theme={'dark-theme'}
        type={'video-overlay'}
        className={'past-event-mobile-video'}
        onClosePress={() => showVideOverlay(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Music & Events',
            breadcrumbLink: RouteNames.musicEvents,
          },
          {
            breadcrumbName: 'All Past Events',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;
  return (
    <div className={'past-event-mobile-card'}>
      <div className={props && props.headingClass}>
        {props && props.type === 'artist' && (
          <div className={'artist-video-data'}>
            <span className={'video-date'}>{date}</span>
            <h2 className={'video-venue'}>{venue}</h2>
            <h2 className={'video-location'}>{location}</h2>
          </div>
        )}
        {videoUrl ? (
          <div style={{ height: '100%' }}>
            <img className={'video-thumb'} src={videoThumbNail} alt={''} />
            <img
              className={
                props && props.type === 'artist'
                  ? 'play-artist-button'
                  : 'play-button'
              }
              src={PlayButton}
              alt={''}
              onClick={() => showVideOverlay(true)}
            />
          </div>
        ) : (
          <img className={'cover-img'} src={image} alt={''} />
        )}
      </div>
      {props && props.type !== 'artist' && (
        <div className={'content'}>
          <h2 className={'slide-heading'}>{heading}</h2>
              <HTMLView
        tagName={'p'}
        className={'slide-description'}
        html={description}
      />
        </div>
      )}
      {showOverlay}
    </div>
  );
};

export default PastEventsMobileCard;
